// article images
import koreanGrandma from "../assets/ProsePics/koreanGrandma.png"
import mulan from "../assets/ArticlePics/mulan.png"
import eeaaooscar from "../assets/ArticlePics/eeaao.png"
import olivia from "../assets/ArticlePics/olivia.png"
import flight from "../assets/ProsePics/Flight.jpg"
import grace from "../assets/ArticlePics/grace.jpg"

import mentalHealth from "../assets/ArticlePics/mentalHealth.jpg"
import plushy from "../assets/ArticlePics/plushy.png"
import parentalExpectations from "../assets/ArticlePics/parentalExpectations.jpg"
import boba from "../assets/ArticlePics/boba.jpg"

//events
import LNY from "../assets/Events/Collabs/LNYTAOAATP.jpg"
import OpenMic from "../assets/Events/Collabs/OpenMicDescent.jpg"
import Valentines from "../assets/Events/Collabs/ValentinesSPOON.jpg"

import GM1 from "../assets/Events/GMs/gm1.jpg"
import GM2 from "../assets/Events/GMs/gm2.jpg"
import GM3 from "../assets/Events/GMs/gm3.jpg"

// components
import homeTemplate from "../components/homeComponents/homeCard.jsx"
import events from "../components/homeComponents/events"
import gms from "../components/homeComponents/gms"
import newsColumn from "../components/homeComponents/newsColumn.jsx"
import "../css/globalComponents.css"
import "../css/homeStructure.css"

const TITLE = 'DAY USC';

const eventsHighlights = [LNY, OpenMic, Valentines];
const eventsNames = ["DAY x TAO x AATP Lunar New Year Celebraiton", "DAY x Descent Open Mic", "DAY x SpoonSC Valentines Snack Exchange"];
const eventsLinks = ["https://www.instagram.com/p/C3X4xqOLrsM/", "https://www.instagram.com/p/C4JVrD7ykTC/", "https://www.instagram.com/p/C3aiJDZR9dz/"];

const gmHighlights = [GM3, GM2, GM1];
const gmNames = ["GM3: Onboarding + Trivia", "GM2: Team Breakouts", "GM1: Pictionary Kickoff"];
const gmLinks = ["https://www.instagram.com/p/DA2PePiPP5m", "https://www.instagram.com/p/DAjVJPhSgrv/", "https://www.instagram.com/p/DASDDyOvcg-/"];


// Rotate in at some point
/*
            {homeTemplate(plushy, "Rilakkuma designed by Aki Kondo", "/plushy", "Ode to Plushy", "POETRY", "Written for the seemingly insignificant things that actually save us when we need it most.",
              "Joseph Caluya")}
            {homeTemplate(koreanGrandma, "AI Art generated by Midjourney", "/halmoni", "Halmoni and Me", "POETRY", "A poem that shows how familial love overcomes even the toughest of obstacles.", "Jessica Tadokoro")}
*/

function Home() {
  return (
    <>
    <title>{ TITLE }</title>
    <div className="py-3">
      <div className="container-fluid" style={{'maxWidth':'90%'}}>
        <div className="row homeRow">
            <div className="col homeCol homeColStretch">
              <div>
                  <h2 className="newsColumn"> Creative</h2>
                  {homeTemplate(flight, "", "/flight", "The Flight", "PROSE", "Story highlighting a familiar feeling Asian-Americans share: the disconnect between one and their mother country's language.", "Andrew Kim")}
                  {homeTemplate(parentalExpectations, "", "/expectations", "Family Expectations Growing Up", "PROSE", "Details the relatable pressures of growing up in an Asian-American household.",
                  "Sydney Fiorentino")}
              </div>
            </div>
            <div className="homeCol homeColStretch col-sm-12 col-md-5">
              <div>
                <h2 className="featuredColumn"> Featured</h2>
                {homeTemplate(olivia, "", "/aaab", 
                "All (Asian)-American Bitch", "ENTERTAINMENT/OPINION", "How Olivia Rodrigo's new song reclaims & challenges boxes surrounding the identity of the Asian-American woman.", "Yi-Ann Li")}
                {homeTemplate(plushy, "Rilakkuma designed by Aki Kondo", "/plushy", "Ode to Plushy", "POETRY", "Written for the seemingly insignificant things that actually save us when we need it most.",
              "Joseph Caluya")}
            </div>
          </div>
          <div className="col homeColStretch">
            {newsColumn()}
          </div>
        </div>
      </div>
    </div>
    </>
    
  );
}

export default Home;
